<template>
  <div class="col-md-6 col-lg-4 card mb-3 px-0">
    <div class="card-header text-light bg1">
      <h5 class="card-title mb-0">Magrathea SIP</h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-2">
          <i class="bi bi-phone-fill icon-size"></i>
        </div>
        <div class="col-sm-8 mt-2" v-if="loading">
          <Spinners />
        </div>
        <div v-else class="col-sm-8 mt-2">
          <span>Number: {{ number }}</span
          ><br />
          <span>Sip: {{ theSip }}</span>
        </div>

        <div class="col-sm-1 my-auto">
          <InfoCard>
            <template v-slot:header>Magrathea Sip</template>
            <template v-slot:body>
              This is the sip that the Magrathea number is set to. If just a
              number shows with no sip information then this is usually the
              underlying DDi or an external number that the main number is
              diverted to
            </template>
          </InfoCard>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="col-md-6 col-lg-4 card mb-3 px-0">
    <div class="card-header text-light bg2">
      <h5 class="card-title mb-0">Client Routing Status</h5>
    </div>
    <div class="card-body" @click="clientRoutingRedirect">
      <div class="row">
        <div class="col-sm-2">
          <i
            class="bi bi-check-circle-fill icon-size text-success"
            v-if="hasClientRouting"
          ></i>
          <i
            class="bi bi-exclamation-octagon-fill icon-size text-danger"
            v-else
          ></i>
        </div>
        <div class="col-sm-8 mt-2" v-if="loading">
          <Spinners />
        </div>
        <div v-else class="col-sm-8 my-auto">
          <p class="my-auto" v-if="hasClientRouting">
            Has Client Routing
          </p>

          <p class="my-auto" v-else>
            No Client Routing
          </p>
        </div>
        <div class="col-sm-1 my-auto">
          <InfoCard>
            <template v-slot:header>Client Routing Status</template>
            <template v-slot:body>
              This shows if the number has a corresponding entry in Client
              Routing
            </template>
          </InfoCard>
        </div>
      </div>
    </div>
  </div>-->
</template>

<script>
import { getSipAddress } from "@/services/magrathea";
import InfoCard from "@/components/InfoCard.vue";
import Spinners from "@/components/Spinners.vue";
let sipInfo = null;

export default {
  async setup(props) {
    sipInfo = await getSipAddress(props.number);
  },

  async mounted() {
    this.sip = sipInfo;
    this.hasClientRouting = this.isNumeric(sipInfo);
  },

  methods: {
    async GetSipAddress(number) {
      this.loading = true;
      this.sip = await getSipAddress(number);
      this.hasClientRouting = this.isNumeric(this.sip);
      this.loading = false;
    },

    isNumeric(num) {
      return !isNaN(num);
    },
    clientRoutingRedirect() {
      if (this.hasClientRouting) {
        window.location = `http://clientrouting/`;
      }
    },
  },

  //parent properties
  props: {
    number: {
      type: String,
      required: true,
    },
    carrierType: {
      type: String,
      requied: true,
    },
  },

  //components private data model
  data() {
    return {
      sip: null,
      hasClientRouting: false,
      loading: false,
    };
  },

  //number watcher
  watch: {
    number: function(val) {
      this.GetSipAddress(val);
    },
  },
  computed: {
    theSip() {
      return this.carrierType === "Magrathea" ? this.sip : "N/A";
    },
  },
  components: {
    InfoCard,
    Spinners,
  },
};
</script>

<style>
.icon-size {
  font-size: 2rem;
}
</style>
